<!--Spiner otkomentirati ako se vrate i slike-->
<!--<div class="loading-overlay" *ngIf="isLoading | async">-->
<!--  <div class="spinner"></div>-->
<!--</div>-->



<div class="container card-list-container py-4">
  <h1 class="text-center mb-5">Digitalna Dnevna Parkirališna Karta</h1>

  <div *ngIf="companyOid === '402880a825447882012544788b750002'" class="container mt-4">
    <p class="text-center text-muted">
      Za dodatne informacije o izdanim DDPK ili o plaćanju iste možete se obratiti putem maila na adresu
      <a href="mailto:infozgp&#64;zgh.hr">infozgp&#64;zgh.hr</a>
      ili putem telefona
      <a href="tel:072500400">072 500 400</a>.
    </p>
  </div>

  <div class="row mb-4">
    <div class="col-md-4 mb-2">
      <input type="text" [(ngModel)]="oib" placeholder="OIB" class="form-control"/>
      <small class="form-text text-muted">
        Unijeti OIB vlasnika ili korisnika vozila (u slučaju kada se vozilo koristi na temelju pravnog posla leasinga).
      </small>
    </div>
    <div class="col-md-4 mb-2">
      <input type="text" [(ngModel)]="licensePlate" placeholder="Registracija" class="form-control"/>
    </div>
    <div class="col-md-4 mb-2">
      <button
        (click)="search()"
        class="btn btn-primary w-100"
        [disabled]="!oib || !licensePlate">
        Pretraga
      </button>
    </div>
  </div>
  

  <div class="row" *ngFor="let card of cards">
    <div class="col-12 mb-4">
      <div class="card shadow-sm p-4 rounded hover-effect" (click)="goToCardDetails(card.ddptOid)">
        <div class="row g-0 align-items-center">
          <!-- Ako vracamo slike samo otkomentirati ovo, sva logika vec postoji -->

<!--          <div class="col-md-4 d-flex justify-content-center align-items-center">-->
<!--            <img [src]="cardImages[card.ddptOid] ? cardImages[card.ddptOid] : 'https://placehold.co/800x400'"-->
<!--                 class="img-fluid rounded" alt="Card Image"/>-->
<!--          </div>-->

          <div class="col-md-12">
            <div class="card-body">
              <div class="card-info mb-3">
                <div class="row mb-2">
                  <div class="col-1 d-flex align-items-center justify-content-center">
                    <i class="fa fa-clock" title="Datum i vrijeme izdavanja DDPK"></i>
                  </div>
                  <div class="col-11 d-flex align-items-center">
                    <div class="date">{{card.ddptValidFrom}}</div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-1 d-flex align-items-center justify-content-center">
                    <i class="fa fa-map-marker" title="Lokacija izdavanja DDPK"></i>
                  </div>
                  <div class="col-11 d-flex align-items-center">
                    <div class="location">{{card.location}}</div>
                  </div>
                </div>
              </div>
              <div class="card-price mb-3">
                <div class="row mb-2">
                  <div class="col-1 d-flex align-items-center justify-content-center">
                    <i class="fa fa-euro-sign" title="Iznos DDPK"></i>
                  </div>
                  <div class="col-11 d-flex align-items-center">
                    <div class="price font-weight-bold">{{card.price}}</div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-1 d-flex align-items-center justify-content-center">
                    <i class="fa fa-car" title="Registracija vozila"></i>
                  </div>
                  <div class="col-11 d-flex align-items-center">
                    <div class="plate font-weight-bold">{{card.licensePlate.replaceAll("-","").toUpperCase()}}</div>
                  </div>
                </div>
              </div>
              <div class="card-time text-muted mt-3">
                <div class="row">
                  <div class="col-1 d-flex align-items-center justify-content-center">
                    <i class="fa fa-calendar" title="Važenje DDPK"></i>
                  </div>
                  <div class="col-11 d-flex align-items-center">
                    <span>{{card.ddptValidFrom}} - {{card.ddptValidTill}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="companyOid === '402880a825447882012544788b750002' && (!cards || cards.length === 0)" class="position-fixed bottom-0 start-0 p-3 text-muted">
    <p class="small mb-0 text-dark">
      Informacije o obradi osobnih podataka dostupne su na ovoj mrežnoj stranici u kategoriji <span class="text-decoration-underline">Informacije</span>, podkategorija 
      <a href="https://www.zagrebparking.hr/informacije/zastita-osobnih-podataka/861">Zaštita osobnih podataka</a>
    </p>
  </div>
</div>
